module.exports = __webpack_public_path__ + "img/gant.a15bf756.svg";